import React from 'react';
import { Typography } from '@mui/material';

type MessageProps = {
  message: any;
};
 
const formatText = (text: any): string => {
  if (typeof text !== 'string') return '';
  
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/\*(.*?)\*/g, '<b>$1</b>')        
    .replace(/_(.*?)_/g, '<i>$1</i>')        
    .replace(/~(.*?)~/g, '<s>$1</s>')       
    .replace(/```(.*?)```/g, '<code>$1</code>') 
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>') // link
    .replace(/\n/g, '<br />');                 
};


const TextMessage: React.FC<MessageProps> = ({ message }) => {
  try {
    const headerText = message?.content?.header?.text || '';
    const bodyText = message?.content?.body?.text || 'No message content available';
    const footerText = message?.content?.footer?.text || '';

    return (
      <>
        {headerText && (
          <Typography
            variant="h6"
            fontWeight="bold"
            gutterBottom
            dangerouslySetInnerHTML={{ __html: formatText(headerText) }}
          />
        )}

        <Typography className='msg-wrapper'
          variant="body1"
          sx={{ whiteSpace: 'pre-wrap', mb: footerText ? 1 : 0 }}
          dangerouslySetInnerHTML={{ __html: formatText(bodyText) }}
        />

        {footerText && (
          <Typography
            variant="caption"
            color="textSecondary"
            dangerouslySetInnerHTML={{ __html: formatText(footerText) }}
          />
        )}
      </>
    );
  } catch (error) {
    return <div>Error displaying message</div>;
  }
};

export default TextMessage;
